import { render } from "./AddLessionUnit.vue?vue&type=template&id=533ae9c8&scoped=true"
import script from "./AddLessionUnit.vue?vue&type=script&lang=js"
export * from "./AddLessionUnit.vue?vue&type=script&lang=js"

import "./AddLessionUnit.vue?vue&type=style&index=0&id=533ae9c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533ae9c8"]])

export default __exports__